"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledDatePicker = exports.DatePicker = exports.defaultTimeFlatpickrOptions = exports.defaultFlatpickrOptions = void 0;
require("flatpickr/dist/flatpickr.css");
const React = __importStar(require("react"));
const react_flatpickr_1 = __importDefault(require("react-flatpickr"));
exports.defaultFlatpickrOptions = {
    altFormat: 'd.m.Y',
    altInput: true,
    altInputClass: 'date-picker form-control',
    disableMobile: true,
    maxDate: 'today',
};
exports.defaultTimeFlatpickrOptions = Object.assign(Object.assign({}, exports.defaultFlatpickrOptions), { altFormat: 'd.m.Y H:i', altInputClass: 'time-enabled date-picker form-control', enableTime: true, time_24hr: true });
const DatePicker = (props) => {
    const defaultOptions = props.enableTime
        ? exports.defaultTimeFlatpickrOptions
        : exports.defaultFlatpickrOptions;
    return (React.createElement(react_flatpickr_1.default, { onChange: (dates) => props.onDateChange(dates[0]), options: Object.assign(Object.assign({}, defaultOptions), props.options), value: props.selectedDate }));
};
exports.DatePicker = DatePicker;
const DisabledDatePicker = (props) => {
    return (React.createElement("input", { className: "form-control date-picker", disabled: true, value: props.selectedDate }));
};
exports.DisabledDatePicker = DisabledDatePicker;
//# sourceMappingURL=DatePicker.js.map